<template>
    <section>
        <div v-if="show">

            <div>
                <b-modal :active="isModalCompositionByYearActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByYear modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByYearActive = false" />
                    </template>
                </b-modal>

                <b-modal :active="isModalCompositionByTypeActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByType modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByTypeActive = false" />
                    </template>
                </b-modal>

                <b-modal :active="isModalCompositionByRemittancesActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByRemittances modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByRemittancesActive = false" />
                    </template>
                </b-modal>

                <b-modal :active="isModalCompositionByTypeEntityActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByTypeEntity modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByTypeEntityActive = false" />
                    </template>
                </b-modal>

                <b-modal :active="isModalCompositionByYearRemittancesActive" aria-modal has-modal-card :destroy-on-hide="true" aria-role="dialog" width="100%"
                    :can-cancel="canCancel">
                    <template>
                        <ModalCompositionByYearRemittancesProject modal-cancel="true" :minYear="minYear" :maxYear="maxYear" :unitId="unitId"
                            @close="isModalCompositionByYearRemittancesActive = false" />
                    </template>
                </b-modal>
            </div>

            <b-collapse v-if="showTypes" :open="isOpenSummary" @open="isOpenSummary = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            Resumen de Proyectos según su Tipología
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <SummaryIndicatorProject :indicator="summary" />
                    </div>
                </div>
            </b-collapse>
            <br v-if="showYears">
            <b-collapse v-if="showYears" :open="isOpenYear" @open="isOpenYear = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 37 - Cantidad de Proyectos por Año de Inicio y Tipo
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <IndicatorByYear :years="indicatorFing37" :title="'project_year'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByYearActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
            <br v-if="showTypes">
            <b-collapse v-if="showTypes" :open="isOpenType" @open="isOpen = true" class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 38 - Proporción de Proyectos por Tipos
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <IndicatorByType :types="indicatorFing38" :title="'project_type'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByTypeActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
            <br v-if="showTypeRemittances">
            <b-collapse v-if="showTypeRemittances" :open="isOpenTypeRemittances" @open="isOpenTypeRemittances = true" 
                class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 39 - Proporción de Montos de Remesas por Proyectos ANID, CORFO y OTROS
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <IndicatorByType :types="indicatorFing39" :title="'remesas'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByRemittancesActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
            <br v-if="showByPartnerPublicPrivate">
            <b-collapse v-if="showByPartnerPublicPrivate" :open="isOpenTypePublicPrivate" @open="isOpenTypePublicPrivate = true" 
                class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 40 - Proporción de Proyectos según Entidades que Aportan Financiamiento
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <IndicatorByType :types="indicatorFing40" :title="'public_private'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByTypeEntityActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
            <br v-if="showByYearsRemittances" >
            <b-collapse v-if="showByYearsRemittances" :open="isOpenSimpleYear" @open="isOpenSimpleYear = true" 
                class="card" animation="slide" aria-id="contentIdForA11y3">
                <template #trigger="props">
                    <div class="card-header" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
                        <p class="card-header-title is-centered">
                            FING 41 - Montos por Remesas por Año
                        </p>
                        <a class="card-header-icon">
                            <b-icon :icon="props.open ? 'angle-down' : 'angle-up'">
                            </b-icon>
                        </a>
                    </div>
                </template>

                <div class="card-content">
                    <div class="content">
                        <IndicatorByYearSimple :years="indicatorFing41" :title="'year_simple_project'" />
                        <div class="columns is-centered my-4">
                            <div class="column has-text-centered">
                                <b-button label="Ver Composición" icon-left="shapes" type="is-primary"
                                    @click="isModalCompositionByYearRemittancesActive = true" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
        </div>
        <div v-else>
            <div class="columns is-centered">
                <div class="column is-6 is-centered has-text-centered">
                    <b-message has-icon type="is-warning">
                        <h1> No se encontraron resultados. Porfavor ingrese nuevos Proyectos para mostrar sus indicadores.</h1>
                    </b-message>
                </div>
            </div>
        </div>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />

    </section>
</template>

<script>
import axios from 'axios'
import IndicatorByType from './indicator_by_type.vue'
import IndicatorByYear from './indicator_by_year.vue'
import IndicatorByYearSimple from './indicator_by_year_simple.vue'
import SummaryIndicatorProject from './summary_indicator_project.vue'
import ModalCompositionByYear from './modal_composition_by_year_project.vue'
import ModalCompositionByType from './modal_composition_by_type_project.vue'
import ModalCompositionByRemittances from './modal_composition_by_remittances_project.vue'
import ModalCompositionByTypeEntity from './modal_composition_by_partner_type_project.vue'
import ModalCompositionByYearRemittancesProject from './modal_composition_by_year_remittances_project.vue'
export default {

    components: {
        IndicatorByType, IndicatorByYear, SummaryIndicatorProject, ModalCompositionByYear, ModalCompositionByType, ModalCompositionByRemittances,
        ModalCompositionByTypeEntity, IndicatorByYearSimple, ModalCompositionByYearRemittancesProject,
    },

    props: [
        'minYear', 'maxYear', 'unitId', 'changeFilter', 'projectTypes', 'partnerEntities'
    ],

    data() {
        return {
            isOpenSummary: true,
            isOpenYear: true,
            isOpenType: true,
            isOpenTypeRemittances: true,
            isOpenTypePublicPrivate: true,
            isOpenSimpleYear: true,
            projectIndicator: {},
            isLoading: false,
            showYears: false,
            showTypes: false,
            showTypeRemittances: false,
            showByPartnerPublicPrivate: false,
            showByYearsRemittances: false,
            show: false,

            //Modals
            canCancel: ["escape"],
            isModalCompositionByYearActive: false,
            isModalCompositionByTypeActive: false,
            isModalCompositionByRemittancesActive: false,
            isModalCompositionByTypeEntityActive: false,
            isModalCompositionByYearRemittancesActive: false,

            //Indicadores
            summary: {
                total: 0,
                count_types: [],
            },
            indicatorFing37: {
                years: [],
                series: [],
            },
            indicatorFing38: [],
            indicatorFing39: [],
            indicatorFing40: [],
            indicatorFing41: {
                years: [],
                series: [],
            }
        }
    },

    async created() {
        this.show = false
        await this.getIndicatorFing37()
        await this.getIndicatorFing38()
        await this.getIndicatorFing39()
        await this.getIndicatorFing40()
        await this.getIndicatorFing41()
        this.show = this.showYears || this.showTypes || this.showTypeRemittances || this.showByPartnerPublicPrivate || this.showByYearsRemittances
    },

    methods: {

        async getIndicatorFing37() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing37',
                    }
                })
                .then(response => {
                    this.indicatorFing37 = {
                        years: [],
                        series: [],
                    }
                    this.showYears = false

                    this.indicatorFing37.years = [...new Set(response.data.map(indicator => indicator.year))].sort((a, b) => a - b)

                    for (let index = 0; index < this.projectTypes.length; index++) {
                        let projectType = this.projectTypes[index]
                        
                        let data = response.data.filter(indicator => indicator.type_id === projectType.id)
                                                .map(indicator => indicator.indicator_value)

                        this.indicatorFing37.series.push({
                            name: projectType.name,
                            data: data,
                        })

                        let suma = data.reduce((acumulador, valorActual) => acumulador + valorActual, 0);
                        this.showYears = this.showYears || (suma > 0)
                    }
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        async getIndicatorFing38() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing38',
                    }
                })
                .then(response => {
                    this.indicatorFing38 = []
                    this.summary = {
                        total: 0,
                        count_types: [],
                    }
                    this.showTypes = false

                    for (let index = 0; index < this.projectTypes.length; index++) {
                        let projectType = this.projectTypes[index]
                        
                        let value = response.data.filter(indicator => indicator.type_id === projectType.id)
                                                .map(indicator => indicator.indicator_value)
                                                .reduce((acumulador, valorActual) => acumulador + valorActual, 0)

                        this.indicatorFing38.push({
                            name: projectType.name,
                            value: value,
                        })

                        this.summary.total += value
                        this.summary.count_types = this.indicatorFing38
                        this.showTypes = this.showTypes || (value > 0)
                    }
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        async getIndicatorFing39() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing39',
                    }
                })
                .then(response => {
                    this.indicatorFing39 = []
                    this.showTypeRemittances = false

                    for (let index = 0; index < this.partnerEntities.length; index++) {
                        let partnerEntity = this.partnerEntities[index]
                        
                        let value = response.data.filter(indicator => indicator.type_id === partnerEntity.id)
                                                .map(indicator => indicator.indicator_value)
                                                .reduce((acumulador, valorActual) => acumulador + valorActual, 0)

                        this.indicatorFing39.push({
                            name: partnerEntity.name,
                            value: value,
                        })

                        this.showTypeRemittances = this.showTypeRemittances || (value > 0)
                    }

                    let valueOthers = response.data.filter(indicator => indicator.type_id === 0)
                                                .map(indicator => indicator.indicator_value)
                                                .reduce((acumulador, valorActual) => acumulador + valorActual, 0)

                    this.indicatorFing39.push({
                        name: 'OTROS',
                        value: valueOthers,
                    })

                    this.showTypeRemittances = this.showTypeRemittances || (valueOthers > 0)
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        async getIndicatorFing40() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing40',
                    }
                })
                .then(response => {
                    this.indicatorFing40 = []
                    this.showByPartnerPublicPrivate = false

                    let valuePublic = response.data.filter(indicator => indicator.type_id === 1)
                                                .map(indicator => indicator.indicator_value)
                                                .reduce((acumulador, valorActual) => acumulador + valorActual, 0)

                    this.indicatorFing40.push({
                        name: 'Públicos',
                        value: valuePublic,
                    })

                    let valuePrivate = response.data.filter(indicator => indicator.type_id === 2)
                                                .map(indicator => indicator.indicator_value)
                                                .reduce((acumulador, valorActual) => acumulador + valorActual, 0)

                    this.indicatorFing40.push({
                        name: 'Privados',
                        value: valuePrivate,
                    })

                    let valueNone = response.data.filter(indicator => indicator.type_id === 3)
                                                .map(indicator => indicator.indicator_value)
                                                .reduce((acumulador, valorActual) => acumulador + valorActual, 0)

                    this.indicatorFing40.push({
                        name: 'Sin Información',
                        value: valueNone,
                    })

                    this.showByPartnerPublicPrivate = (valuePublic > 0) || (valuePrivate > 0) || (valueNone > 0)
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

        async getIndicatorFing41() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-values-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing41',
                    }
                })
                .then(response => {
                    this.indicatorFing41 = {
                        years: [],
                        series: [],
                    }
                    this.showByYearsRemittances = false

                    for (let index = 0; index < response.data.length; index++) {
                        const indicator = response.data[index]
                        this.indicatorFing41.years.push(String(indicator.year))
                        this.indicatorFing41.series.push(indicator.indicator_value)

                        this.showByYearsRemittances = this.showByYearsRemittances || (indicator.indicator_value > 0)
                    }
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },

    },

    watch: {
        async changeFilter() {
            this.show = false
            await this.getIndicatorFing37()
            await this.getIndicatorFing38()
            await this.getIndicatorFing39()
            await this.getIndicatorFing40()
            await this.getIndicatorFing41()
            this.show = this.showYears || this.showTypes || this.showTypeRemittances || this.showByPartnerPublicPrivate || this.showByYearsRemittances
            deep: true
        },
    },

}
</script>